import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type RecruitingJobCategoryFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  status: defaultStatus,
} as RecruitingJobCategoryFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/recruiting-job-categories', name: 'Recruiting Job Categories' },
];
